import React from 'react';

import { WorkflowBody } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

import { StepLayout } from './StepLayout';

const useStyles = makeStyles()(theme => ({
  bodyContainer: {
    backgroundColor: theme.appColors.background,
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(2, 0, 2, 0),
  },
}));

export function AddRecipientsStep({ workflowId }: { workflowId: UUID }): JSX.Element {
  const { classes } = useStyles();
  return (
    <div>
      <div className={classes.bodyContainer}>
        <StepLayout n={3} title="Add steps">
          <WorkflowBody
            CannotViewWF={() => null}
            NoWorkflow={() => null}
            showProgress={false}
            workflowId={workflowId}
          />
        </StepLayout>
      </div>
    </div>
  );
}
